import { render, staticRenderFns } from "./CarLineOrGoods.vue?vue&type=template&id=5081ee56&scoped=true&"
import script from "./CarLineOrGoods.vue?vue&type=script&lang=js&"
export * from "./CarLineOrGoods.vue?vue&type=script&lang=js&"
import style0 from "./CarLineOrGoods.vue?vue&type=style&index=0&id=5081ee56&lang=less&scoped=true&"
import style1 from "./CarLineOrGoods.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5081ee56",
  null
  
)

export default component.exports